import axios, { AxiosResponse } from 'axios';
import { AddRepairLocationInput } from 'modules/Instruments/models';

export default function createAsync(apiUrl: string) {
  return function api<TResponse>(
    input: AddRepairLocationInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/repair-location`,
          method: 'POST',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
